module.exports = __webpack_public_path__ + "images/ducati_small9f8e8c7e4e88ebba08a6376b4c0efd4e.png";